import config from './config.json'
export const { serverPath, clientPath, wpPath } = config[process.env.REACT_APP_NODE_ENV]
